import { useSelectedFeature } from 'map-feature-info'
import { Marker as View } from 'ms-map-gl'

const isPoint = (geometry) => {
  return geometry?.type === 'Point' && geometry?.coordinates?.length === 2
}

export const Marker = () => {
  const selectedFeature = useSelectedFeature()

  const { geometry } = selectedFeature

  if (!isPoint(geometry)) return null

  const { coordinates } = geometry
  const [longitude, latitude] = coordinates

  return (
    <View
      latitude={latitude}
      longitude={longitude}
    />
  )
}
